@if (isLoggedIn) {
    <footer>
    <div class="container-footer">
        <div class="footer-content">
            <div class="container-sx">
                <p>
                    {{"inclusion-index.pdf.footer-disclaimer" | translate}}
                </p>
                <p>Project number: 2024-1-FR01-KA220-VET-000245350</p>
            </div>

            <div class="container-dx">
                <a class="logo-link" href="#">
                    <img src="img/EN_Co-fundedbytheEU_RGB_WHITE Outline.png" alt="Co-funded by the EU" />
                </a>
            </div>
        </div>
    </div>
</footer>
}